/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccountStatus } from './AccountStatus';
import {
    AccountStatusFromJSON,
    AccountStatusFromJSONTyped,
    AccountStatusToJSON,
} from './AccountStatus';
import type { AccountRole } from './AccountRole';
import {
    AccountRoleFromJSON,
    AccountRoleFromJSONTyped,
    AccountRoleToJSON,
} from './AccountRole';

/**
 * Account Schema
 * @export
 * @interface Account
 */
export interface Account {
    /**
     * Account ID
     * @type {string}
     * @memberof Account
     */
    id: string;
    /**
     * Account Username
     * @type {string}
     * @memberof Account
     */
    username: string;
    /**
     * Account Email
     * @type {string}
     * @memberof Account
     */
    email: string;
    /**
     * 
     * @type {AccountStatus}
     * @memberof Account
     */
    status: AccountStatus;
    /**
     * 
     * @type {AccountRole}
     * @memberof Account
     */
    role: AccountRole;
    /**
     * Account Given Name
     * @type {string}
     * @memberof Account
     */
    givenName: string;
    /**
     * Account Family Name
     * @type {string}
     * @memberof Account
     */
    familyName: string;
    /**
     * Account Phone Number
     * @type {string}
     * @memberof Account
     */
    phoneNumber: string;
    /**
     * Hide Phone Number From Members
     * @type {boolean}
     * @memberof Account
     */
    hidePhoneFromMembers: boolean;
    /**
     * Hide Email From Members
     * @type {boolean}
     * @memberof Account
     */
    hideEmailFromMembers: boolean;
    /**
     * Account Last Seen Date
     * @type {Date}
     * @memberof Account
     */
    lastSeenDate: Date;
    /**
     * Account Created Date
     * @type {Date}
     * @memberof Account
     */
    createdDate: Date;
    /**
     * Account Updated Date
     * @type {Date}
     * @memberof Account
     */
    updatedDate: Date;
}



/**
 * Check if a given object implements the Account interface.
 */
export function instanceOfAccount(value: object): value is Account {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('givenName' in value) || value['givenName'] === undefined) return false;
    if (!('familyName' in value) || value['familyName'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('hidePhoneFromMembers' in value) || value['hidePhoneFromMembers'] === undefined) return false;
    if (!('hideEmailFromMembers' in value) || value['hideEmailFromMembers'] === undefined) return false;
    if (!('lastSeenDate' in value) || value['lastSeenDate'] === undefined) return false;
    if (!('createdDate' in value) || value['createdDate'] === undefined) return false;
    if (!('updatedDate' in value) || value['updatedDate'] === undefined) return false;
    return true;
}

export function AccountFromJSON(json: any): Account {
    return AccountFromJSONTyped(json, false);
}

export function AccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): Account {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'username': json['username'],
        'email': json['email'],
        'status': AccountStatusFromJSON(json['status']),
        'role': AccountRoleFromJSON(json['role']),
        'givenName': json['given_name'],
        'familyName': json['family_name'],
        'phoneNumber': json['phone_number'],
        'hidePhoneFromMembers': json['hide_phone_from_members'],
        'hideEmailFromMembers': json['hide_email_from_members'],
        'lastSeenDate': (new Date(json['last_seen_date'])),
        'createdDate': (new Date(json['created_date'])),
        'updatedDate': (new Date(json['updated_date'])),
    };
}

export function AccountToJSON(value?: Account | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'username': value['username'],
        'email': value['email'],
        'status': AccountStatusToJSON(value['status']),
        'role': AccountRoleToJSON(value['role']),
        'given_name': value['givenName'],
        'family_name': value['familyName'],
        'phone_number': value['phoneNumber'],
        'hide_phone_from_members': value['hidePhoneFromMembers'],
        'hide_email_from_members': value['hideEmailFromMembers'],
        'last_seen_date': ((value['lastSeenDate']).toISOString()),
        'created_date': ((value['createdDate']).toISOString()),
        'updated_date': ((value['updatedDate']).toISOString()),
    };
}

